export default {
    namespaced: true,

    state: {
        tveApiHost: null,
    },

    mutations: {
        SET_TVE_API_HOST(state, tveApiHost) {
            state.tveApiHost = tveApiHost
        }
    },

    actions: {
        loadServerData({ commit }, serverData) {
            if (serverData && typeof serverData === 'object') {
                commit('SET_TVE_API_HOST', serverData.tveApiHost)
            }
        }
    },

    getters: {
        getTveApiHost: (state) => {
            return state.tveApiHost
        }
    }
}
